import { useSearchParams } from "react-router-dom";


export type TSelectFilter = {
    label: string
    name: string
    options: Array<{name: string, value: string | number}>
}


export default function SelectFilter(props: TSelectFilter) {
    const [searchParams, setSearchParams] = useSearchParams();

    const onChange = (data: Record<string, any>) => {
        const params = new URLSearchParams(searchParams);
        params.set(props.name, `${data.value}`);
        setSearchParams(params);
    }

    const clear = () => {
        const params = new URLSearchParams(searchParams);
        params.delete(props.name);
        setSearchParams(params);
    }

    return (
        <div className="px-4 py-3">
            <div className="flex justify-between text-xs text-zinc-500 font-medium mb-4">
                <h4 className="">
                    {props.label}
                </h4>

                <button className="text-primary" onClick={clear}>
                    Reset
                </button>
            </div>

            <div className="grid grid-cols-2 gap-4 text-xs">
                {
                    props.options.map((item) => (
                        <label 
                            className="flex" 
                            htmlFor={item.name} 
                            key={item.name}
                        >
                            <input 
                                type="radio" 
                                name="order-status" 
                                id={item.name} 
                                value={item.name} 
                                onChange={() => onChange(item)}
                                checked={`${item.value}` == searchParams.get(props.name)}
                            />
                            <span className="capitalize ml-2">
                                {item.name}
                            </span>
                        </label>
                    ))
                }
            </div>
        </div>
    )
}